// extracted by mini-css-extract-plugin
export default {"root":"CampaignItem_root__bAORS"};